import WizardProfileService from '../../services/wizardprofile.service';
import _ from 'lodash';
/*
    private Long id;
    private String fieldName;
    private String profileName;
    private String mfUsersGUID;
    private String profileContent;
    private Boolean published;
 */

const state = {
    dataList: [],
    activeTable: '',
    wizardProfiles: [],
    backendData: new Map()
};

const mutations = {
    addProfile(state, profile) {
        _.remove(state.wizardProfiles, {id: profile.id});
        state.wizardProfiles.push(profile);
    },
    activateTable(state, tableName) {
        if (state.activeTable !== '') {
            state.backendData.set(state.activeTable, state.wizardProfiles);
        }
        state.wizardProfiles = [];

        if (state.backendData.has(tableName)) {
            state.wizardProfiles = state.backendData.get(tableName);
        }
        state.activeTable = tableName;
    },
    setProfiles(state, profileList) {
        state.wizardProfiles = profileList;
    },
    deleteProfile(state, id) {
        state.wizardProfiles = state.wizardProfiles.filter(value => value.id !== id);
    }
};

const getters = {
    getProfiles: (state) => {
        return state.wizardProfiles;
    },
}

const actions = {
    addProfile(context, profile) {
        // Konvertiert den ProfileContent zu einem einfachen String
        let contentString = JSON.stringify(profile.profileContent);
        profile.profileContent = contentString;

        return WizardProfileService.saveProfile(profile).then(r => {
            let savedProfile = r.data;
            let profileContent = JSON.parse(savedProfile.profileContent);
            savedProfile.profileContent = profileContent;
            context.commit('addProfile', savedProfile);
            return savedProfile;
        })
    },
    activateTable(context, fieldName) {
        WizardProfileService.loadProfilesForField(fieldName).then(r => {
            // Konvertiert das JSON zurück zu einem Object/Array
            for (let profile of r.data) {
                if (fieldName === "genre") {
                    console.log("Genre: " + profile.profileContent);
                }
                let profileContent = JSON.parse(profile.profileContent);
                if (fieldName === "genre") {
                    console.log("Genre2: " + JSON.stringify(profileContent));
                }
                profile.profileContent = profileContent;
            }
            context.commit('setProfiles', r.data);
        })
    },
    removeProfile(context, profile) {
        WizardProfileService.deleteProfile(profile.id).then(() => {
            context.commit("deleteProfile", profile.id);
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
